import { AssetTypes } from 'libs.localization.common';
export const getActivityNamesAsset = (study) => ({
    type: AssetTypes.ACTIVITY_NAMES,
    id: study.id,
    version: '1',
    messages: study
        .getAllActivities()
        .filter((activity) => !('isBuiltIn' in activity.details && activity.isBuiltIn) && !activity.isVisitConfirmation)
        .reduce((acc, item) => item.libraryId && !acc.some((i) => i.namespace === item.libraryId)
        ? [
            ...acc,
            {
                namespace: item.libraryId,
                messages: { value: item.name },
            },
        ]
        : acc, []),
    preview: {
        engine: 'react',
        id: AssetTypes.ACTIVITY_NAMES,
        default_viewport: 'iosSmall',
        default_product_version: study.productTemplate,
        info: {
            display_name: 'Screening',
            list: [],
        },
    },
});
